import {
  HomeOutlined,
  Home,
  Inventory2Outlined,
  Inventory2,
  PersonAddAlt1Outlined,
  PersonAddAlt1,
  AutoGraphOutlined,
  AutoGraph,
  MedicalInformationOutlined,
  MedicalInformation,
} from '@mui/icons-material';

export const getTabConfig = (isPwa) => [
  {
    label: 'Home',
    path: isPwa ? '/pwa-main-menu' : '/',
    inactiveIcon: <HomeOutlined />,
    activeIcon: <Home />,
    key: 'home',
    visible: true,
  },
  {
    label: 'Inventory',
    path: '/inventory',
    inactiveIcon: <Inventory2Outlined />,
    activeIcon: <Inventory2 />,
    key: 'inventory',
  },
  {
    label: 'Benefits',
    path: '/benefits/mybenefits',
    inactiveIcon: <MedicalInformationOutlined />,
    activeIcon: <MedicalInformation />,
    key: 'my_benefits',
  },
  {
    label: 'Performance',
    path: '/my-performance/network-performance',
    inactiveIcon: <AutoGraphOutlined />,
    activeIcon: <AutoGraph />,
    key: 'network_performance',
  },
];

